<app-header></app-header>
<div class="image-container">
    <img src="assets/navimage.png" width="100%" alt="Your Image">
    <div class="image-text">
      <p>Public Disclosure</p>
    </div>
</div> 



<div class="container mt-5 pb-4">
    <div class="row">
        <div class="col-lg-12 col-sm-12 ">
            <div class="brdr_btm">
                <span class="content3">A. GENERAL INFORMATION </span>
            </div>
            <div>
                <table mat-table [dataSource]="dataSource" class="mt-4 mat-table">

                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef>S. No. </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                    </ng-container>
                  
               

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.name}} </td>
                      </ng-container>

                      <ng-container matColumnDef="information">
                        <th mat-header-cell *matHeaderCellDef >INFORMATION</th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="{'highlight-row': element.highlight, 'even-row': i % 2 === 0 ? 'even-row' : ''}"> 
                            <div class="d-flex flex-column" *ngIf="element.multipleLines" >

                                <span *ngFor="let line of element.information.split('/')">{{line}}</span>
                               
                            </div>
                            
                            <div *ngIf="!element.multipleLines"><span>{{element.information}}</span></div> </td>
                      </ng-container>
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                   
                    
                  </table>
            </div>
            <div class="brdr_btm">
                <span class="content3">B. DOCUMENTS AND INFORMATION </span>
            </div>
            <div>
                <table mat-table [dataSource]="dataSource1" class="mt-4 mat-table">

                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef>S. No. </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                    </ng-container>
                  
               

                    <ng-container matColumnDef="information" class="information-column">
                        <th mat-header-cell *matHeaderCellDef>DOCUMENTS/ INFORMATION</th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.information}} </td>
                      </ng-container>

                      <ng-container matColumnDef="link">
                        <th mat-header-cell *matHeaderCellDef>VIEW DOCUMENTS</th>
                        <td mat-cell *matCellDef="let element; let i = index" class="brdr" [ngClass]="{'highlight-row': element.highlight, 'even-row': i % 2 === 0 ? 'even-row' : ''}">
                          <div *ngIf="!element.multipleLines">
                            <!-- Check if element has routerLink property -->
                            <ng-container *ngIf="element.routerLink; else externalLink">
                              <a class="highlight-row" [routerLink]="element.routerLink">{{element.linkText}}</a>
                            </ng-container>
                            <!-- If not using routerLink, use the external link -->
                            <ng-template #externalLink>
                              <a class="highlight-row" href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                            </ng-template>
                          </div>
                        </td>
                      </ng-container>
                      
                  
                    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;"></tr>
                   
                    
                  </table>
            </div>


            <div class="brdr_btm">
                <span class="content3">C. RESULT AND ACADEMICS </span>
            </div>
            <div>
                <table mat-table [dataSource]="dataSource2" class="mt-4 mat-table">

                    <ng-container matColumnDef="slno">
                      <th mat-header-cell *matHeaderCellDef>S. No. </th>
                      <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                    </ng-container>
                  
               

                    <ng-container matColumnDef="information" class="information-column">
                        <th mat-header-cell *matHeaderCellDef>DOCUMENTS/ INFORMATION</th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.information}} </td>
                      </ng-container>

                      <ng-container matColumnDef="link">
                        <th mat-header-cell *matHeaderCellDef >VIEW DOCUMENTS</th>
                        <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="{'highlight-row': element.highlight, 'even-row': i % 2 === 0 ? 'even-row' : ''}"> 
                             
                            <div *ngIf="!element.multipleLines">
                              <a class="highlight-row" href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                            </div> 
                          </td>
                      </ng-container>
                  
<!--  <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef> view </th>
                        <td mat-cell *matCellDef="let element">
                          <a href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                        </td>
      </ng-container> -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                   
                    
                  </table>
            </div>
            <div class="brdr_btm">
              <span class="content3">D. STAFF TEACHING </span>
           </div>
           <div>
            <table mat-table [dataSource]="dataSource3" class="mt-4 mat-table">

                <ng-container matColumnDef="slno">
                  <th mat-header-cell *matHeaderCellDef>S. No. </th>
                  <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
                </ng-container>
              
           

                <ng-container matColumnDef="information">
                    <th mat-header-cell *matHeaderCellDef>INFORMATION</th>
                    <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.information}} </td>
                  </ng-container>

                  <ng-container matColumnDef="link">
                    <th mat-header-cell *matHeaderCellDef >DETAILS</th>
                    <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="{'highlight-row': element.highlight, 'even-row': i % 2 === 0 ? 'even-row' : ''}"> 
                         
                        <div *ngIf="element.link!=''">
                          <a class="highlight-row" href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                        </div> 
                        <div *ngIf="element.link==''">
                          {{element.linkText}}
                        </div> 
                      </td>
                  </ng-container>
              
<!--  <ng-container matColumnDef="view">
                    <th mat-header-cell *matHeaderCellDef> view </th>
                    <td mat-cell *matCellDef="let element">
                      <a href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                    </td>
  </ng-container> -->

                <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
               
                
              </table>
           </div>
           <div class="brdr_btm">
            <span class="content3">D. SCHOOL INFRASTRUCTURE </span>
         </div>
         <div>
          <table mat-table [dataSource]="dataSource4" class="mt-4 mat-table">

              <ng-container matColumnDef="slno">
                <th mat-header-cell *matHeaderCellDef>S. No. </th>
                <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.slno}} </td>
              </ng-container>
            
         

              <ng-container matColumnDef="information" class="information-column">
                  <th mat-header-cell *matHeaderCellDef>INFORMATION</th>
                  <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="i % 2 === 0 ? 'even-row' : ''"> {{element.information}} </td>
                </ng-container>

                <ng-container matColumnDef="link">
                  <th mat-header-cell *matHeaderCellDef >DETAILS</th>
                  <td mat-cell *matCellDef="let element;let i = index" class="brdr" [ngClass]="{'highlight-row': element.highlight, 'even-row': i % 2 === 0 ? 'even-row' : ''}"> 
                       
                      <div *ngIf="element.link!=''">
                        <a class="highlight-row" href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                      </div> 
                      <div *ngIf="element.link==''">
                        {{element.linkText}}
                      </div> 
                    </td>
                </ng-container>
            
<!--  <ng-container matColumnDef="view">
                  <th mat-header-cell *matHeaderCellDef> view </th>
                  <td mat-cell *matCellDef="let element">
                    <a href="{{element.link}}" target="_blank">{{element.linkText}}</a>
                  </td>
</ng-container> -->

              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
             
              
            </table>
         </div>
        </div>
    </div>
  </div>
  <app-footer></app-footer>